<template>
  <div class="number-input">
    <input
      ref="inputDom"
      :value="myNum"
      type="text"
      maxlength="3"
      @input="inputNumber"
      @mousemove.prevent.stop
      @dblclick.prevent
      @click.prevent
      @blur="blur"
    >
    <div class="add-plus-content">
      <div class="add-plus-btn">
        <span @mousedown.prevent="addPlus(1)">
          <iconfont
            class="normal-format"
            name="#icon11-110xuanzeshang"
            font-size="8px"
          ></iconfont>
          <iconfont
            class="hover-format"
            name="#icon11-110xuanzeshangjiaohu"
            font-size="8px"
          ></iconfont>
        </span>
        <span @mousedown.prevent="addPlus(-1)">
          <iconfont
            class="normal-format"
            name="#icon11-111xuanzexia"
            font-size="8px"
          ></iconfont>
          <iconfont
            class="hover-format"
            name="#icon11-111xuanzexiajiaohu"
            font-size="8px"
          ></iconfont>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  model: {
    prop: 'myNum'
  },
  props: {
    myNum: {
      type: Number,
      default: 0
    },
    minNum: {
      type: Number,
      default: 0
    },
    maxNum: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {
      inputStr: '0'
    };
  },
  watch: {
    priTime() {},
    myNum() {
      //console.log('this.myNum + val', this.myNum);
    }
  },
  mounted() {
    //this.$bus.on('formatTimeInput.init', this.initData);
  },
  beforeDestroy() {
    //this.$bus.off('formatTimeInput.init', this.initData);
  },
  methods: {
    addPlus(val) {
      this.$emit('input', this.myNum + val);
    },
    inputNumber() {
      //console.log('inputNumber inputNumber', this.$refs.inputDom.value);
      let n = parseInt(this.$refs.inputDom.value.toString().replace(/[^\d]/g, ''));
      n = n > this.maxNum ? this.maxNum : n < this.minNum ? this.minNum : n;
      if (isNaN(n)) {
        n = this.minNum;
      }
      if (!n && n !== 0) {
        n = this.minNum;
      }
      this.$emit('input', n);
      this.$refs.inputDom.value = this.myNum;
    },
    blur() {
      if (this.$refs.inputDom.value == this.myNum) return;
      this.$emit('input', parseInt(this.$refs.inputDom.value));
      //this.$emit('blur', { type: this.limitType, val: v });
    }
    // checkKey(event){
    //   let r = (/[\d]/.test(String.fromCharCode(event.keyCode)));
    //   console.log('aaaaaaaaaaaaa', r, event.keyCode);
    //   return r;
    // }
  }
};
</script>
<style lang="scss" scoped>
.number-input {
  position: relative;
  background: #ffffff;
  border: 1px solid #e5e6eb;
  border-radius: 4px;
  width: 100%;
  height: 100%;
  text-align: center;
  overflow: hidden;
  box-sizing: border-box;

  input {
    width: 100%;
    height: 100%;
    line-height: 40px;
    padding-left: 12px;
    letter-spacing: 1px;
    @media (max-width: 1600px) {
      padding-left: 8px;
      line-height: 30px;
    }
  }
}
.add-plus-content {
  position: absolute;
  top: 0;
  right: 5px;
  height: 100%;
  @media (max-width: 1600px) {
    transform: scale(0.8);
    right: 2px;
  }
}

.add-plus-btn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;

  > span {
    width: 18px;
    height: 36%;
    cursor: pointer;
    display: flex;
    align-items: flex-start;
    justify-content: center;

    &:first-child {
      align-items: flex-end;
      margin-top: -1px;
    }

    &:last-child {
      margin-top: 2px;
    }

    .hover-format {
      display: none;
    }

    &:hover {
      .normal-format {
        display: none;
      }
      .hover-format {
        display: block;
      }
    }
  }

  @media (max-width: 1600px) {
    .add-plus-btn {
      > span {
        width: 12px;

        &:first-child {
          align-items: flex-end;
          margin-top: 0px;
        }

        &:last-child {
          margin-top: 0px;
        }

        > svg {
          transform-origin: center;
          transform: scale(0.8);
        }
      }
    }
  }
}
</style>
